import { PlaylistUploadDto } from 'collaboration-service';
import { LoaderInline } from 'imaginarity-react-ui';
import * as React from 'react';
import { PlaylistEditActions, useDispatchPLE, useSelectorPLE } from './PlaylistEdit';
interface PlaylistUpdaterProps {
    playlist?: PlaylistUploadDto & { id?: string };
    children: React.ReactNode;
    groupId?: string;
}

const PlaylistUpdater = (p: PlaylistUpdaterProps) => {
    const { playlist, groupId } = p;
    const groupid = groupId ?? playlist?.group_id;
    const [loading, setLoading] = React.useState<boolean>(false);
    const d = useDispatchPLE();
    const statePlaylist = useSelectorPLE((state) => state?.playlist);

    React.useEffect(() => {
        return () => {
            //console.log('cleanUp => ');
            d(PlaylistEditActions.batch([
                PlaylistEditActions.setPlaylist(undefined),
                PlaylistEditActions.setOriginalPlaylist(undefined),
            ]))
        }
    }, [d]);

    //console.log('statePost => ', statePost);
    //console.log('post => ', post);


    React.useEffect(() => {

        if (statePlaylist?.id !== playlist?.id || statePlaylist === undefined) {
            //console.log("setting post! => ", post)
            d(PlaylistEditActions.batch([
                PlaylistEditActions.setPlaylist(playlist),
                PlaylistEditActions.setOriginalPlaylist(playlist),
            ]))
        }
    },
        [d, playlist, statePlaylist])


    React.useEffect(() => {
        const load = async () => {
            setLoading(false);
        }
        setLoading(true);
        load();
    }, [groupid, d])

    if (statePlaylist === undefined || loading)
        return <LoaderInline active />;
    //console.log('PostUpdate => ', statePost);
    return <>
        {p.children}
    </>;
}
export default PlaylistUpdater;